export enum BlockOrientation {
  Line = 'line',
  Column = 'column',
}
